<template>
  <div>
    <div class="d-flex flex-row">
      <v-autocomplete
        :ref="'auto' + id"
        :loading="uploading"
        v-model="selectedFile"
        :disabled="disabled"
        :items="internalFiles"
        :rules="rules"
        :label="label"
        return-object
        item-value="description"
        item-text="description"
        @change="emitFiles($event)"
      >
        <template v-slot:selection="data">
          <v-chip
            large
            v-bind="data.attrs"
            :input-value="data.selected"
            @click="data.select"
          >
            {{ data.item.description }}
            <v-icon class="chip-btn" @click="preview(data.item)">
              visibility
            </v-icon>
            <v-icon class="chip-btn" @click="download(data.item)">
              file_download
            </v-icon>
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title
                v-html="data.item.description"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
      <v-btn
        style="margin-top:15px"
        fab
        small
        color="primary"
        @click="onAddClick"
        :loading="uploading"
        :disabled="disabled"
      >
        <v-icon style="margin:0!important">add</v-icon>
      </v-btn>
      <input
        :id="id"
        ref="uploader"
        style="display: none"
        type="file"
        @change="handleFileChange"
      />
    </div>
    <v-dialog persistent scrollable v-model="showPreview" max-width="480">
      <v-card>
        <v-container
          fluid
          grid-list-md
          v-if="previewFile === null || previewFile === undefined"
        >
          <v-layout row justify-center>
            <v-flex xs12 sm6 md4 lg3>
              <v-progress-circular indeterminate></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
        <div v-else-if="previewFile.ExtensionType.FileType === 'Adobe Reader'">
          <pdf
            id="pdfdiv"
            :src.sync="src"
            :page="1"
            class="centered-div"
            :style="'width: 100%;'"
            @error="pdfError"
            @loaded="pdfLoaded"
            @progress="pdfProgress"
          ></pdf>
        </div>
        <div
          v-else-if="previewFile.ExtensionType.FileType === 'Image'"
          class="file-preview-container"
        >
          <v-img ref="img" :src.sync="src"></v-img>
        </div>
        <div
          v-else-if="previewFile.ExtensionType.FileType === 'text'"
          class="file-preview-container"
          style="font-size:1em;overflow-y:auto"
        >
          {{ src }}
        </div>
        <v-card-text v-else class="file-preview-container">
          <h5>{{ $t("download_center.labels.no_preview") }}</h5>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="
              showPreview = false;
              previewFile = null;
            "
          >
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import pdf from "vue-pdf";
import { saveAs } from "file-saver";
import AuthService from "@/services/auth.service";
import { TokenService } from "@/services/token.service";
import { mapGetters } from "vuex";

export default {
  name: "single-file-upload2",
  props: [
    "id",
    "uploadMsg",
    "rules",
    "label",
    "keepRevisions",
    "fileUploadUrl",
    "zipDownloadUrl",
    "getFilesUrl",
    "ownerId",
    "categories",
    "tags",
    "groups",
    "filesIds",
    "disabled",
    "currentFolder",
    "file",
    "files"
  ],
  components: {
    pdf,
  },
  data() {
    return {
      error: false,
      uploading: false,
      selectedFile: null,
      internalFiles: [],
      src: null,
      showPreview: false,
      fileData: null,
      pageCount: 0,
      previewFile: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  watch: {
    files: {
      handler() {
        this.loadFiles();
      },
      deep: true,
    },
  },
  mounted() {
    if (this.file !== null && this.file !== undefined) {
      this.file.description = this.createDescription(this.file);
      this.internalFiles = [this.file];
    }
    this.loadFiles();
    this.getFile();
  },
  methods: {
    async getFile() {
      if (this.filesIds && this.filesIds !== null) {
        try {
          this.emitUploadStart();
          this.selectedFile = null;
          this.internalFiles = [];
          const result = (await axios.post(
            `${this.getFilesUrl}`,
            this.filesIds
          )).data;

          for (const item of result) {
            const newfile = await this.makeFile(item);
            const internalItem = { file: item, File: newfile };
            internalItem.description = this.createDescription(internalItem);
            this.selectedFile = internalItem;
            this.internalFiles.push(internalItem);
          }
          this.emitUploadEnd();
        } catch (error) {
          this.emitUploadError(error);
        }
      }
    },
    loadFiles() {
      if (this.files && this.files !== null) {
        for (const internalItem of this.files) {
          if (this.internalFiles.filter(o=>o.file.Id === internalItem.file.Id).length === 0) {
            this.internalFiles.push(internalItem);
          }
        }
      }
    },
    createDescription(item) {
      return (
        item.file.Name +
        "--" +
        new Date(Date.parse(item.file.DateCreated)).toLocaleString()
      );
    },
    emitFiles(data) {
      this.uploading = false;
      // for (const f of data) {
      //   delete f.description;
      // }
      this.$emit("emit-files", data);
    },
    emitUploadStart() {
      this.uploading = true;
      this.$emit("emit-upload-start");
    },
    emitUploadEnd() {
      this.uploading = false;
      this.$emit("emit-upload-end");
    },
    emitUploadError(error) {
      this.uploading = false;
      this.$emit("emit-upload-error", error);
    },
    pdfError(error) {
      console.log("pdf error: ", error);
    },
    pdfLoaded() {
      console.log("pdf loaded");
    },
    pdfProgress(progress) {
      console.log("pdf progress: ", progress);
    },
    async preview(item) {
      console.log("preview triggered: ", item);
      try {
        this.showPreview = true;

        const res = await axios.get(`${this.fileUploadUrl}/${item.file.Id}`);
        const blob = this.$files.b64toBlob(res.data);

        this.fileData = new File([blob], item.Name, {
          type: blob.type,
        });

        if (item.file.ExtensionType.FileType === "text") {
          this.src = await this.readFileAsTextAsync(this.fileData);
        } else if (item.file.ExtensionType.FileType === "Image") {
          this.src = await this.readFileAsDataUrlAsync(this.fileData);
        } else if (item.file.ExtensionType.FileType === "Adobe Reader") {
          const src = await this.readFileAsDataUrlAsync(this.fileData);
          this.src = pdf.createLoadingTask(src);
          this.src.promise.then((p) => {
            this.pageCount = p.numPages;
          });
        }
        this.previewFile = item.file;
      } catch (error) {
        this.error = error;
      }
    },
    readFileAsDataUrlAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    readFileAsTextAsync(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;
        reader.readAsText(file);
      });
    },
    onAddClick() {
      const uploader = document.getElementById(this.id);
      if (uploader !== null && uploader !== undefined) {
        uploader.click();
      }
      // this.$refs.uploader.click();
    },
    async handleFileChange(e) {
      const files = e.target.files;
      console.log(files);
      if (!files) {
        return;
      }
      if (files.length === 0) {
        return;
      }
      try {
        if (this.internalFiles === null || this.internalFiles === undefined) {
          this.internalFiles = [];
        }
        const existingFile = this.internalFiles.filter(
          (o) => o.file.Name === files[0].name
        );
        if (existingFile.length === 0) {
          const newItem = await this.createUploadFile(files[0]);
          this.emitUploadStart();
          let token = TokenService.getToken();
          const res = (await axios.post(this.fileUploadUrl, [newItem], {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })).data;
          for (const fileItem of res) {
            this.selectedFile = { file: fileItem };
          }

          console.log(this.selectedFile);
          this.emitFiles(this.selectedFile);

          this.selectedFile.description = this.createDescription(
            this.selectedFile
          );

          this.internalFiles.push(this.selectedFile);
        } else {
          this.selectedFile = existingFile[0];
        }
      } catch (error) {
        this.emitUploadError(error);
      }
    },
    async makeFile(item) {
      const res = (await axios.get(`${this.fileUploadUrl}/${item.Id}`)).data;
      const blob = this.$files.b64toBlob(res);
      return new File([blob], item.Name, { type: blob.type });
    },
    async createUploadFile(file) {
      const res = await this.readFileAsDataUrlAsync(file);
      const tempFolder =
        this.currentFolder == null ? null : { Path: this.currentFolder };
      const user = await AuthService.getUser();
      const itemFile = {
        file: {
          OwnerId: user.profile.sub, //this.ownerId,
          Owner: { UserName: this.user },
          Name: file.name,
          FileSize: file.size,
          KeepRevisions: this.keepRevisions,
          Temporary: true,
          MarkedForDeletion: false,
          IsPublic: false,
          Folder: tempFolder,
          Categories: this.categories
            ? this.categories.map((x) => ({ Name: x }))
            : null,
          Tags: this.tags ? this.tags.map((x) => ({ Name: x })) : null,
          Group: this.groups ? this.groups.map((x) => ({ Name: x })) : null,
          Locations: [],
        },
        Base64Contents: res.split(",")[1],
        File: file,
      };

      return itemFile;
    },
    async download(item) {
      const res = await axios.get(`${this.fileUploadUrl}/${item.file.Id}`);
      const data = this.$files.b64toBlob(res.data);
      saveAs(data, item.file.Name);
    },
  },
};
</script>

<style scoped>
.text--white /deep/ label {
  color: white;
}
</style>
<style>
.chip-btn {
  margin-left: 5px !important;
}
.width-fit-content {
  width: fit-content;
}
.file-preview-container {
  height: 450px;
  width: 450px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
}
.preview-box {
  height: 300px;
  width: 300px;
}
</style>
